import Col from 'ravenjs/lib/Col';
import PropTypes from 'prop-types';
import React from 'react';
import Row from 'ravenjs/lib/Row';
import Typography from 'ravenjs/lib/Typography';
import styled from 'styled-components';
import { getThemeProps } from 'ravenjs/utils/theme';

import { sanitizeMarkup } from 'ravenjs/utils/sanitize';

const SubNavTitleStyled = styled.div`
    height: 100%;
    margin-right: 20px;
    padding: 5px 5px 5px 15px;
    width: auto;
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('SubNavTitle.styles')};
`;

const SubNavTitle = ({ caption, subtitle, title }) => (
    <SubNavTitleStyled>
        <Row
            alignItems="flex-start"
            direction="column"
            gutter={false}
            height="100%"
            justify="center"
        >
            {subtitle && (
                <Col gutter={false}>
                    <Typography
                        dangerouslySetInnerHTML={sanitizeMarkup(subtitle)}
                        gutterBottom="0"
                        gutterTop="0"
                    />
                </Col>
            )}
            <Col gutter={false}>
                <Row direction="row" height="100%" alignItems="center" gutter={false}>
                    <Row direction="row" alignItems="baseline" gutter={false}>
                        {title && (
                            <Typography
                                dangerouslySetInnerHTML={sanitizeMarkup(title)}
                                gutterBottom="0"
                                gutterTop="0"
                                gutterRight="10px"
                                type="headline"
                            />
                        )}
                        {caption && (
                            <Typography
                                dangerouslySetInnerHTML={sanitizeMarkup(caption)}
                                gutterBottom="0"
                                gutterTop="0"
                            />
                        )}
                    </Row>
                </Row>
            </Col>
        </Row>
    </SubNavTitleStyled>
);

SubNavTitle.propTypes = {
    /**
     * The caption rendered next to the title.
     */
    caption: PropTypes.string,
    /**
     * The sub-title rendered above the title.
     */
    subtitle: PropTypes.string,
    /**
     * The main title for the sub-navigation.
     */
    title: PropTypes.string,
};

SubNavTitle.defaultProps = {
    caption: null,
    subtitle: null,
    title: null,
};

export default SubNavTitle;
